(function() {
  'use strict';

  const SCROLL_THRESHOLD = 50;
  let sectionHeader = null;
  let ticking = false;

  function init() {
    sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    updateHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }

  function updateHeader() {
    if (!sectionHeader) return;

    if (window.scrollY > SCROLL_THRESHOLD) {
      sectionHeader.classList.add('luvia-scrolled');
    } else {
      sectionHeader.classList.remove('luvia-scrolled');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('section-header')) {
      sectionHeader = null;
      init();
    }
  });
})();
